import { fetchDialerToken as apiFetchDialerToken } from '@/api/dialer'

export default {
  namespaced: true,
  state: () => ({
    token: null,
    error: null
  }),
  mutations: {
    SET_TOKEN(state, token) { state.token = token },
    SET_ERROR(state, err)   { state.error = err   }
  },
  actions: {
    async fetchToken({ commit }) {
      try {
        const res = await apiFetchDialerToken()
        commit('SET_TOKEN', res.data.token)
        return res.data.token
      } catch (e) {
        commit('SET_ERROR', 'Failed to fetch token')
        throw e
      }
    }
  },
  getters: {
    currentToken: s => s.token,
    callError:    s => s.error
  }
}
